import { useLazyQuery } from "@apollo/client";
import { useCallback } from "react";
import {
  GetMeetingNewPageQueryQuery,
  GetMeetingNewPageQueryQueryVariables,
} from "types/graphql-schema";

import getMeetingQuery from "@apps/meeting-new/graphql/get-meeting-query";
import cache, { currentUserVar } from "@cache/cache";
import usePusher from "@components/use-pusher/use-pusher";

export default function PusherMeetingTopicsUpdated({
  channelName,
}: {
  channelName: string;
}) {
  const currentUser = currentUserVar();

  const [fetchMeeting] = useLazyQuery<
    GetMeetingNewPageQueryQuery,
    GetMeetingNewPageQueryQueryVariables
  >(getMeetingQuery);

  const handleMeetingUpdated = useCallback(
    ({ meeting_id }: { meeting_id: number }) => {
      const meetingCacheId = cache.identify({
        id: meeting_id,
        __typename: "MeetingNode",
      });
      if (meetingCacheId) {
        fetchMeeting({
          variables: {
            meetingId: meeting_id,
          },
        });
      }
    },
    [currentUser],
  );

  usePusher(channelName, "meeting_topics_update", handleMeetingUpdated);

  return null;
}
